import { escapeRegExp } from "./escape-regex-search-string";

export function replaceAll(str: string, find: string, replace: string): string {
  return (str || "").replace(new RegExp(escapeRegExp(find), "g"), replace);
}
